// extracted by mini-css-extract-plugin
export default {"tabletGap":"HomeCompany_tabletGap__vCgeT"};